import { takeLatest, takeEvery, call, put, delay } from 'redux-saga/effects';
import Type from '../../actions';
import * as api from '../../../server';
import { message } from 'antd';

// start
export function* startMeeting(action) {
  try {
    const { url, systemNum, isOnline, cb = window.noop } = action;
    const data = {
      mediationID: systemNum,
      systemNum: systemNum,
      isOnline: isOnline
    }
    const res = yield call(api.postDetailSubmit, url, data)
    if(res.status === 0) {
      switch (action.isOnline) {
        case 1:
          yield call(cb, res.trialCode);
          break;
        case 2:
          yield call(cb, res.des);
          break;
        default: return
      }
    }
    else {
      message.error(res.des);
    }
  } catch (error) {
    message.error(error)
  }
}

export function* startMeetingRequest() {
  yield takeLatest(Type.START_MEETING, startMeeting)
}